import { render, staticRenderFns } from "./ResellerPaymentPopup.vue?vue&type=template&id=25f0d6a1"
import script from "./ResellerPaymentPopup.vue?vue&type=script&lang=js"
export * from "./ResellerPaymentPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports